import { makeClient } from "./client";
import { createHttpGateway } from "./httpGateway";

// One client. Tests intercept it with MSW (see src/test/handlers.ts) instead of
// swapping this module for a hand-written gateway.
export const api = makeClient(createHttpGateway());
export { ApiError } from "./client";
export type { Client } from "./client";
